<template>
  <div class="news-detail">
    <cc-header-nav title="详情"></cc-header-nav>
    <div class="article-detail">
      <div class="article-title">
        <h3 v-html="article.title"></h3>
      </div>
      <div class="article-time" v-html="article.date"></div>
      <section class="article-content" v-html="article.content"></section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'news-detail',
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      article: {}
    }
  },
  computed: {
    ...mapGetters(['getLoadNewsContent'])
  },
  async created () {
    await this.LOAD_NEWS_CONTENT(this.id)
    if (this.getLoadNewsContent.code === 1) {
      this.article = this.getLoadNewsContent.data.new_content
    }
  },
  methods: {
    ...mapActions(['LOAD_NEWS_CONTENT'])
  }
}
</script>

<style lang="scss" scoped>
.article-detail {
  background-color: #fff;
  padding: 10px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}
.article-title h3 {
  font-weight: 400;
  color: #333;
  line-height: 30px;
  font-size: 20px;
}
.article-time {
  color: #666;
  font-size: 14px;
  line-height: 25px;
  border-bottom: 1px solid #ccc;
}
.article-content {
  padding-top: 10px;
}
/deep/.article-content img {
  display: block;
  width: auto;
  max-width: 100%;
}
</style>
